import { render } from "./COVIDOccupancyNoticeLayout.vue?vue&type=template&id=ed22632a&scoped=true&ts=true"
import script from "./COVIDOccupancyNoticeLayout.vue?vue&type=script&lang=ts"
export * from "./COVIDOccupancyNoticeLayout.vue?vue&type=script&lang=ts"

import "./COVIDOccupancyNoticeLayout.vue?vue&type=style&index=0&id=ed22632a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed22632a"]])

export default __exports__